import { useEffect, useState } from "react";
import { HERO_SLIDES, SITE } from "../data/site";

const BADGES = [
  "Starting from IDR 250K",
  "Canggu & Ubud Stores",
  "Premium Linen-Focused Collection",
  "Open Daily 9 AM – 9 PM",
];

const HeroSlider = () => {
  const [i, setI] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setI((p) => (p + 1) % HERO_SLIDES.length), 5500);
    return () => clearInterval(id);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="top"
      data-testid="hero-slider"
      className="relative w-full h-[100svh] min-h-[640px] overflow-hidden"
    >
      {HERO_SLIDES.map((s, idx) => (
        <div
          key={s.src}
          className={`hero-slide ${i === idx ? "is-active" : ""}`}
          data-testid={`hero-slide-${idx}`}
        >
          <img
            src={s.src}
            alt={s.alt}
            className="w-full h-full object-cover"
            loading={idx === 0 ? "eager" : "lazy"}
            fetchPriority={idx === 0 ? "high" : "auto"}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/65" />
        </div>
      ))}

      <div className="relative z-10 h-full container-tjb flex items-end pb-16 md:pb-24">
        <div className="max-w-2xl text-[hsl(var(--cream))]">
          <p className="eyebrow !text-[hsl(var(--cream))]/85 fade-up">
            Triple J Bali — Canggu & Ubud
          </p>
          <h1 className="h-display mt-4 fade-up-2">
            Simple Luxury <em className="not-italic italic font-light" style={{fontStyle:"italic"}}>Linen Wear</em> for Bali
          </h1>
          <p className="mt-5 max-w-xl text-base sm:text-lg text-[hsl(var(--cream))]/90 leading-relaxed fade-up-3">
            Premium linen-focused outfits for tropical days in Bali. Easy,
            breathable, and elegant pieces for men and women, available in
            Canggu and Ubud.
          </p>

          <div className="mt-8 flex flex-wrap gap-3 fade-up-3">
            <button
              data-testid="hero-shop-collection"
              onClick={() => scrollTo("collection")}
              className="btn-primary bg-[hsl(var(--cream))] !text-[hsl(var(--ink))] hover:opacity-90"
            >
              Shop Collection
            </button>
            <button
              data-testid="hero-visit-stores"
              onClick={() => scrollTo("locations")}
              className="btn-ghost-light"
            >
              Visit Our Stores
            </button>
          </div>
        </div>
      </div>

      {/* dot indicators */}
      <div className="absolute bottom-8 right-6 md:right-12 z-10 flex gap-2">
        {HERO_SLIDES.map((_, idx) => (
          <button
            key={idx}
            data-testid={`hero-dot-${idx}`}
            onClick={() => setI(idx)}
            aria-label={`Go to slide ${idx + 1}`}
            className={`h-[3px] rounded-full transition-all duration-500 ${
              i === idx ? "w-10 bg-[hsl(var(--cream))]" : "w-5 bg-[hsl(var(--cream))]/45"
            }`}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroSlider;
